import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";

type IProps = {
  label: string;
  id?: string;
  name?: string;
  value?: any;
  disabled?: boolean;
};

export const Checkbox = React.forwardRef<HTMLInputElement, IProps>(
  ({ label, disabled, ...rest }, ref) => {
    const { colors } = useTheme();
    const { css } = useFela();

    return (
      <label
        className={css({
          cursor: disabled ? "not-allowed" : "pointer",
          color: colors.DARK_GREY,
          fontWeight: 600,
          fontSize: 16,
          lineHeight: "24px",
          marginBottom: 12,
        })}
      >
        <input
          className={css({
            display: "none",
            nested: {
              "&:checked + span::before": {
                borderColor: colors.GRADIENT_PURPLE,
              },
              "&:checked + span::after": {
                borderRadius: 0,
                content: "''",
                position: "absolute",
                width: 12,
                height: 6,
                left: 4,
                top: 7,
                transform: "rotate(-45deg)",
                borderLeft: `2px solid ${colors.GRADIENT_PURPLE}`,
                borderBottom: `2px solid ${colors.GRADIENT_PURPLE}`,
              },
            },
          })}
          ref={ref}
          disabled={disabled}
          type="checkbox"
          {...rest}
        />
        <span
          className={css({
            position: "relative",
            paddingLeft: 30,
            nested: {
              "::before": {
                position: "absolute",
                top: 2,
                left: 0,
                content: "''",
                width: 20,
                height: 20,
                display: "inline-block",
                borderRadius: 2,
                borderWidth: 2,
                borderStyle: "solid",
                borderColor: "#7D8894",
              },
            },
          })}
        >
          {label}
        </span>
      </label>
    );
  },
);
